module.exports = __webpack_public_path__ + "static/media/BizTech3.8dc36919.jpg";